import { ContextMenuContext } from "@/providers/ContextMenuProvider";
import type { ContextMenuProviderProps } from "@/types/providers/contextMenu";

import { useContext } from "react";

export default function useContextMenu() {
  const context = useContext(ContextMenuContext) as ContextMenuProviderProps;
  // if (!context) throw new Error("useContextMenu must be used within an ContextMenuProvider");
  return context;
}
